import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import axios from "axios";
import validatePasswordFormat from "../passwordValidator";
import "../css/EditMyInfo.css";

function EditMyInfo() {
  const customer = useSelector((state) => state.customer);
  const [customerData, setCustomerData] = useState({
    firstname: customer.firstname,
    lastname: customer.lastname,
    email: "",
    address: "",
    phoneNumber: "",
    currentPassword: "",
    newPassword: "",
  });
  const [warning, setWarning] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getCustomer = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/customers/${customer.id}`,
        { headers: { Authorization: `Bearer ${customer.token}` } },
      );
      const { email, address, phoneNumber } = response.data;
      console.log(response.data);
      setCustomerData({ ...customerData, email, address, phoneNumber });
    } catch (err) {
      console.log(err.response.data.msg);
    }
  };
  const handleChange = (ev) => {
    const newValue = ev.target.value;
    const field = ev.target.id;
    const copyOfCustomerData = { ...customerData };
    copyOfCustomerData[field] = newValue;
    setCustomerData(copyOfCustomerData);
    setWarning(null);
  };
  const handleSubmit = async (ev) => {
    ev.preventDefault();
    if (
      customerData.firstname === "" ||
      customerData.lastname === "" ||
      customerData.email === "" ||
      customerData.address === "" ||
      customerData.phoneNumber === "" ||
      customerData.currentPassword === ""
    )
      return setWarning("Please complete all the fields.");
    if (customerData.newPassword !== "" && !validatePasswordFormat(customerData.newPassword))
      return setWarning("New password does not adhere to the format we require.");
    try {
      const response = await axios({
        method: "patch",
        url: `${process.env.REACT_APP_API_URL}/customers/${customer.id}`,
        data: customerData,
        headers: { Authorization: `Bearer ${customer.token}` },
      });
      console.log(response.data);
      dispatch({
        type: "LOGIN",
        payload: {
          ...customer,
          firstname: customerData.firstname,
          lastname: customerData.lastname,
        },
      });
      setWarning("Your information was successfully uploaded.");
    } catch (err) {
      console.log(err);
      setWarning("Incorrect credentials.");
    }
  };

  useEffect(() => {
    if (customer) return getCustomer();
    navigate("/login");
  }, [customer]);

  return (
    <>
      <Navbar />
      <section className="container mt-5 mb-5">
        <h3>Edit my information</h3>
        <form onSubmit={handleSubmit} className="row g-3 mt-3">
          <div className="col-lg-4 cold-md-6 col-sm-12">
            <label htmlFor="firstname" className="form-label">
              First Name*
            </label>
            <input
              type="text"
              className="form-control"
              id="firstname"
              value={customerData.firstname}
              onChange={handleChange}
            />
          </div>
          <div className="col-lg-4 cold-md-6 col-sm-12">
            <label htmlFor="lastname" className="form-label">
              Last Name*
            </label>
            <input
              type="text"
              className="form-control"
              id="lastname"
              onChange={handleChange}
              value={customerData.lastname}
            />
          </div>
          <div className="col-lg-4 cold-md-6 col-sm-12">
            <label htmlFor="address" className="form-label">
              Address*
            </label>
            <input
              type="text"
              className="form-control"
              id="address"
              onChange={handleChange}
              value={customerData.address}
            />
          </div>

          <div className="col-lg-4 cold-md-6 col-sm-12">
            <label htmlFor="phoneNumber" className="form-label">
              Phone Number*
            </label>
            <input
              type="text"
              className="form-control"
              id="phoneNumber"
              onChange={handleChange}
              value={customerData.phoneNumber}
            />
          </div>

          <div className="col-lg-4 cold-md-6 col-sm-12">
            <label htmlFor="currentPassword" className="form-label">
              Current Password*
            </label>
            <input
              type="password"
              className="form-control"
              id="currentPassword"
              onChange={handleChange}
              value={customerData.currentPassword}
            />
          </div>

          <div className="col-lg-4 cold-md-6 col-sm-12">
            <label htmlFor="newPassword" className="form-label">
              New Password** (leave empty if meant to remain unchanged)
            </label>
            <input
              type="password"
              className="form-control"
              id="newPassword"
              onChange={handleChange}
              value={customerData.newPassword}
            />
          </div>

          <div className="col-12">
            <p>(*) Required</p>
            <p>
              (**) Passwords must have more than 7 characters and contain at least one number and
              one letter.
            </p>
            <div className="d-flex align-items-center">
              <button type="submit" className="btn btn-primary rounded-pill border p-2 text-center btn-box">
                <i className="fa-solid fa-arrow-right pe-2"></i>
                Save changes
              </button>
              {warning && <p className="text-danger fw-bold mb-0 ml-3">{warning}</p>}
            </div>
          </div>
        </form>
      </section>
      <Footer />
    </>
  );
}

export default EditMyInfo;
